import { IUser } from 'kach-clients'

export const buildUserName = (
  triggeredBy: Pick<IUser, 'firstName' | 'lastName'>,
  isDeleted: boolean = false,
) =>
  !triggeredBy
    ? ''
    : `${triggeredBy.firstName || ''} ${triggeredBy.lastName || ''} ${
        isDeleted ? '(inactivo)' : ''
      }`
